import React from 'react'

import { Container } from './styles'

const Footer: React.FC = () => {
  const currentYear: number = new Date().getFullYear()

  return (
    <Container>
      <p>&copy; {currentYear} | Solar21 - Todos os direitos reservados.</p>
    </Container>
  )
}

export default Footer
